import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import DoctorsListBody from "components/ClinicalManagement/Doctors/DoctorsListBody";

const Doctors = () => {
  useEffect(() => {
    document.title = "Doctors";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <DoctorsListBody />
    </main>
  );
};

export default Doctors;
